import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { WPService } from 'src/app/core/http/web/wp.service';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { SuscribeWPService } from 'src/app/core/http/web/suscribe.service';
import { AlertsUtilitiesAppService } from 'src/app/core/services/utilities/alerts-app.service';
//const states_JSON = require('./states.json')
declare var $: any;



@Component({
  selector: 'app-modal-suscribe',
  templateUrl: './modal-suscribe.component.html',
  styleUrls: ['./modal-suscribe.component.scss']
})
export class ModalSubscribeComponent {
  public subscribeData: any = null;
  public statesJSON: any = [];
  public errors: any = null;
  public loadings: any = true;
  public form: FormGroup;
  public submited: boolean;
  @Output() eventForm: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private wpServ: WPService,
    private suscrService: SuscribeWPService,
    private formB: FormBuilder,
    private alertServ: AlertsUtilitiesAppService
  ) {
    this.getDataModal();
    console.log('LIST STATES', this.statesJSON)
  }

  initFormBuilder() {
    this.form = this.formB.group({
      fNombre: ['', [Validators.required]],
      fApellidos: ['', [Validators.required]],
      fGenero: ['', []],
      fEstado: ['', []],
      fProductos: this.formB.array([]),
      fTerminos: ['', [Validators.required]]
    });
    this.updateProductos(this.subscribeData.products);
  }
  getDataModal() {
    this.wpServ.getGeneral('general_options', 'form_suscripcion').subscribe(data => {
      // console.log('datos de susripción: ', data);
      this.subscribeData = data.data.form_suscripcion;
      this.initFormBuilder();
    });
  }
  get f() { return this.form.controls; }
  /***********************Actualizar arreglo de productos************************* */
  updateProductos(dat: any) {
    this.clearFormArray('fProductos');
    for (let index = 0; index < dat.length; index++) {
      this.addItemCategory(dat[index]);
    }
  }
  get fProductosArr(): FormArray {
    return this.form.get('fProductos') as FormArray;
  }
  addItemCategory(data: any): void {
    this.fProductosArr.push(this.createItem(data.id, data.description, ''));
  }
  createItem(value: string, label: string, valueSelected: string): FormGroup {
    return this.formB.group({ fStatus: [value === valueSelected ? true : '', []], fValue: [value, []], fLabel: [label, []] });
  }
  clearFormArray(fName) {
    const control = <FormArray>this.form.controls[fName];
    control.controls = [];
  }
  /******************************************************************************** */


  submit() {
    this.submited = true;
    console.log('Value form: ', this.form.invalid, this.form.value);
    if (this.form.valid) {
      this.saveData();
    }
  }
  saveData() {
    const dLocal = JSON.parse(localStorage.getItem('newsletter'));
    const data = {
      nombre: this.form.value.fNombre,
      apellidos: this.form.value.fApellidos,
      email: dLocal.email,
      genero: this.form.value.fGenero,
      estado: this.form.value.fEstado,
      pInteres: this.form.value.fProductos.filter(f => f.fStatus),
      id: dLocal.id
    };
    this.suscrService.setNewSuscription(data).subscribe(result => {
      console.log('Save suscripción: ', result);
      if (result.id > 0) {
        $('#newsletterModal').modal('hide');
        this.alertServ.sweetAl('Gracias por suscribirte', 'success', 'OK');
        this.eventForm.emit({status: 1});
        this.form.controls.fNombre.setValue('');
        this.form.controls.fApellidos.setValue('');
        this.form.controls.fGenero.setValue('');
        this.form.controls.fEstado.setValue('');
        this.form.controls.fProductos.setValue('');
        this.form.controls.fTerminos.setValue('');
      }
    }, err => {
      console.error(err);
      this.errors = err;
    });
  }
}
